// Figma: https://www.figma.com/design/S3yxsM3h4CuTy6ZZjxpedQ/NEW-TSAB-Customer-App?node-id=15266-472354
// Shows traveler count from a booking (traveler.travelerCount)

import { useTranslation } from 'react-i18next'

function UsersIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" stroke="#17181A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <circle cx="9" cy="7" r="4" stroke="#17181A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M22 21v-2a4 4 0 0 0-3-3.87" stroke="#17181A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M15 3.13a4 4 0 0 1 0 7.75" stroke="#17181A" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default function TravelerCount({ count }) {
  const { t } = useTranslation()

  if (!count || count < 1) return null

  return (
    <div className="flex gap-3 items-center py-3 w-full">
      <div className="shrink-0 size-11 flex items-center justify-center">
        <UsersIcon />
      </div>
      <div className="flex-1 min-w-0">
        <span className="text-[17px] font-medium tracking-[-0.34px] leading-[22px] text-on-surface">
          {t('label-passenger-count', { count })}
        </span>
      </div>
    </div>
  )
}
